<template>
  <div class="Pos_main">
    <div class="UpdataMsg">*每月13日更新前月全渠道数据(强生月)</div>
    <div class="pos_all">
      <div class="all_nav">
        <p>历史月销售额趋势</p>
        <span></span>
      </div>
      <div class="charts">
        <HisToryCharts :myDefTime="TimeDef"></HisToryCharts>
      </div>
    </div>
    <div class="stage_nav">
      <p>全渠道销售报告</p>
      <span></span>
    </div>
    <div class="history_table">
      <div class="dateSel">
        <el-date-picker
          style="border: 1px solid #d1534b; width:105px"
          align="center"
          v-model="month"
          type="month"
          placeholder="选择历史月"
          :editable="false"
          :clearable="false"
          @change="changeDate()"
          format="yyyy-MM"
          value-format="yyyyMM"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <img
          src="../../assets/jpg/data.png"
          alt
          style="width:12px;height:12px;position: absolute;position: absolute;left: 4%; top: 50%;margin-top: -6px;margin-left: -6px;"
        />
      </div>
      <ButThrTable :updataDate="month"></ButThrTable>
    </div>
  </div>
</template>
<script>
import HisToryCharts from "@/components/ButThr/ButThr_Charts";
import ButThrTable from "@/components/ButThr/ButThr_Table";

export default {
  name: "Pos",
  data() {
    return {
      month: sessionStorage.getItem("DefTime"),
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e7 - 2592000000;
        },
      },
      TimeDef: "",
    };
  },
  methods: {
    changeDate() {},
    getUpdateTime() {
      this.$addr.post("weekly/getUpdateDate").then((res) => {
        this.TimeDef = res.data.data[0].hostMm;
      });
    },
  },
  components: {
    HisToryCharts,
    ButThrTable,
  },
  created() {
    this.getUpdateTime();
  },
};
</script>
<style  scoped>
.UpdataMsg {
  position: absolute;
  right: 5%;
  height: 20px;
  min-width: 60px;
  top: 0px;
  background: #01B198;
  z-index: 99;
  padding: 3px 8px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
}
.dateSel {
  position: relative;
  left: 20px;
  z-index: 5;
  margin: 0 0 3px;
}
.history_table {
  position: relative;
  margin: 10px 0 40px;
}
.Pos_main {
  position: relative;
  left: 0;
  width: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  overflow: hidden;
}
.Pos_main .all_nav,
.Pos_main .Tmall_nav,
.Pos_main .stage_nav {
  background: #f6f6ff;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius: 20px;
  background: #01B198;
  border-radius: 22.5008px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.Pos_main .all_nav {
  margin: 28.8px 20px 0px 16px;
}
.Pos_main .Tmall_nav {
  margin: 0px 20px 0px 16px;
}
.Pos_main .stage_nav {
  margin: 0px 20px 10px 16px;
}

.Pos_main .all_nav p,
.Tmall_nav p,
.stage_nav p {
  margin-left: 15px;
  font-family: "PingFangSC-Medium";
  font-size: 16px;
  color: #ffffff;
}

.Pos_main .all_nav span,
.Tmall_nav span,
.stage_nav span {
  opacity: 0.6;
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #f3f3f3;
  text-align: center;
  margin-right: 15px;
}
.Pos_main .pos_all {
  min-height: 270px;
  width: 100%;
  margin: 0 auto;
}
.pos_Tmall {
  overflow: hidden;
}
.charts {
  min-height: 280px;
  padding: 0 16.5px;
  position: relative;
  margin: 20px 0;
}
/deep/ .van-dropdown-menu__bar{
  height: 100% !important;
  background: none !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ButThr/ButThr_History.vue